import { Badge, Box } from "@mui/material";
import { Zap } from "lucide-react";

type Props = {
  selected: boolean;
  availableCount: number;
  activeCount: number;
  unreadCount?: number;
  size?: number;
};

export default ({
  selected,
  availableCount,
  activeCount,
  unreadCount = 0,
  size = 20,
}: Props) => {
  const hasActive = activeCount > 0;
  const hasAvailable = availableCount > 0;
  const hasUnread = !hasActive && unreadCount > 0;
  const badgeCount = hasActive
    ? activeCount
    : hasUnread
      ? unreadCount
      : hasAvailable
        ? availableCount
        : 0;
  const badgeColor = hasActive || hasUnread ? "#F5A623" : "#4CAF50";
  const iconColor = hasActive || hasUnread ? "#F5A623" : "#8E9598";

  return (
    <Box
      sx={{
        padding: "8px 10px 9px 8px",
        marginBottom: "2px",
        marginRight: "-10px",
        borderRadius: "8px",
        ...(selected && {
          background: "#E2EEEC",
        }),
      }}
    >
      <Badge
        badgeContent={badgeCount}
        overlap="circular"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          "& .MuiBadge-badge": {
            backgroundColor: badgeColor,
            color: "white",
            fontSize: 10,
            fontWeight: 600,
            height: 16,
            minWidth: 16,
            top: -2,
            right: -2,
            border: "2px solid white",
            boxShadow: "0 1px 2px rgba(0,0,0,0.15)",
          },
        }}
      >
        <Zap
          size={size}
          color={iconColor}
          fill={hasActive || hasUnread ? iconColor : "none"}
        />
      </Badge>
    </Box>
  );
};
